export const THREAD_INITIAL_MESSAGES_COUNT_TO_FETCH_V1 = 5;
export const THREAD_INITIAL_MESSAGES_COUNT_TO_FETCH_V2 = 100;